<template lang="pug">
  v-navigation-drawer(
    v-model='drawer' 
    color='black' 
    :mini-variant.sync="mini"
    right
    app
    permanent
    max-width='875'
  )
    v-list-item.px-3.py-1
      v-btn(icon='' @click.stop='mini = !mini')
        v-icon(v-if="mini") mdi-chevron-left
        v-icon(v-else) mdi-chevron-right
      v-list-item-avatar(tile)
        ato-img(:img="$store.getters.user.portraitImage" :contain="false" :aspectRatio="1" type="tiny")
      v-list-item-title {{$store.getters.user.name}}
      v-btn(icon to="/logout")
        v-icon mdi-logout
    v-divider
    v-list-item(:href="$store.getters.FE_URL" target="_blank")
      v-list-item-icon
        v-icon mdi-arrow-top-right-thin-circle-outline
      v-list-item-content
        v-list-item-title {{$store.getters.FE_URL}}

    v-divider
    v-card.mx-auto.black
      v-list(subheader)
        v-subheader Links
        v-list-item(v-if="item.visible" :to="item.link" v-for="item in linkItems" :key="item.title")
          v-list-item-icon
            v-icon {{item.icon}}
          v-list-item-content
            v-list-item-title {{item.title}}
            v-list-item-subtitle {{item.subtitle}}

      v-divider
</template>

<script>
export default {
  data: () => ({
    drawer: true,
    mini: false,
    settings: 0,
  }),

  computed: {
    linkItems() {
      const isRestrictedCurator = this.$store.getters.isCurator && !this.$store.getters.isCore
      return [
        { link: "/me", title: "Dein Profil", subtitle: "", icon: "mdi-information", visible: this.$store.getters.isCore || this.$store.getters.isCurator || this.$store.getters.isArtist },
        { link: "/artists", title: "Personen", subtitle: "", icon: "mdi-karate", visible: this.$store.getters.isCore || this.$store.getters.isCurator },
        { link: "/artworks", title: "Kunst", subtitle: "", icon: "mdi-go-kart-track", visible: this.$store.getters.isCore || this.$store.getters.isCurator || this.$store.getters.isArtist },
        { link: "/exhibitions", title: "Veranstaltungen", subtitle: "", icon: "mdi-go-kart-track", visible: this.$store.getters.isCore || this.$store.getters.isCurator || this.$store.getters.isArtist },
        { link: "/info-grid", title: "Info Grid", subtitle: "", icon: "mdi-view-grid", visible: this.$store.getters.isCore },
        { link: "/mediathek", title: "Mediathek", subtitle: "", icon: "mdi-image-multiple", visible: this.$store.getters.isCore },
        { link: "/magazine", title: "Magazin", subtitle: "", icon: "mdi-layers", visible: (this.$store.getters.isCore || this.$store.getters.isEditor) && !isRestrictedCurator && !this.$store.getters.isArtist },
        { link: "/blog", title: "Blog", subtitle: "", icon: "mdi-post", visible: this.$store.getters.isCore || this.$store.getters.hasBlogRole },
        { link: "/aenderungen", title: "Änderungen", subtitle: "", icon: "mdi-history", visible: this.$store.getters.isCore },
        { link: "/contacts", title: "Kontakte", subtitle: "", icon: "mdi-contacts", visible: this.$store.getters.isCore },
        { link: "/logbuch", title: "Logbuch", subtitle: "", icon: "mdi-format-list-text", visible: this.$store.getters.isCore },
        { link: "/layout-editor", title: "Layout Editor", subtitle: "", icon: "mdi-layers", visible: this.$store.getters.isCore },
        { link: "/settings", title: "Settings", subtitle: "Admin Einstellungen", icon: "mdi-account-cog", visible: this.$store.getters.isCore },
      ]
    }
  }
}
</script>
